import { useEffect, useMemo } from "react";
import { useRoomContext,VideoTrack,type TrackReference,} from "@livekit/components-react";
import { Track } from "livekit-client";
import { useLiveSessionStore } from "../../../../stores/useLiveSessionStore";
export const LiveKitRoomVideo = () => {
  const isVideoOn = useLiveSessionStore((state) => state.isVideoOn);
  const room = useRoomContext();
  const sendMessageToEngine = useLiveSessionStore((state) => state.sendMessageToEngine);
  useEffect(() => {
    if (!room) return;
    const localParticipant = room.localParticipant;
    const updateCamera = async () => {
      try {
        if (isVideoOn) {
          await localParticipant.setCameraEnabled(true);
          sendMessageToEngine("addLiveStreamLog", {
            action: "start",
            metadata:{ "filename": ""}
          });   
        } else {
          await localParticipant.setCameraEnabled(false);
          sendMessageToEngine("addLiveStreamLog", {
            action: "stop"  ,
            metadata:{"filename": ""}         
          });
        }
      } catch (error) {
        console.error("Error updating camera state:", error);
      }
    };
    void updateCamera();
    return () => {
    };
  }, [isVideoOn, room]);
  const trackRefToRender: TrackReference | undefined = useMemo(() => {
    if (!room) return undefined;
    const publication = room.localParticipant.getTrackPublication(
      Track.Source.Camera
    );
    if (!publication || !publication.track) return undefined;
    return {
      participant: room.localParticipant,
      source: Track.Source.Camera,
      publication,
    };
  }, [room, isVideoOn]);
  if (!isVideoOn || !trackRefToRender) return null;
  return (
    <VideoTrack
      trackRef={trackRefToRender}
      key={trackRefToRender.publication.trackSid}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        backgroundColor: "black",
      }}
    />
  );
};
